module.exports = __webpack_public_path__ + "static/media/2016118129891-46.caeb43f7.jpg";